/** Country-aware i18n key for the company registry-id label.
 *
 * FR → "SIREN / SIRET", ES → "CIF / NIF", GB → "Company number", … .
 * Shared by the partner org form, the beneficiary form, and the session
 * participant form so every "company identity" field group labels the
 * registration number the same way. Falls back to a generic label for
 * countries we don't special-case.
 */
export function registrationLabelKey(country: string): string {
  const c = (country || "").toUpperCase();
  const map: Record<string, string> = {
    FR: "partner.form.regFR",
    ES: "partner.form.regES",
    GB: "partner.form.regGB",
    DE: "partner.form.regDE",
    IT: "partner.form.regIT",
    NL: "partner.form.regNL",
    BE: "partner.form.regBE",
    PT: "partner.form.regPT",
  };
  return map[c] ?? "partner.form.regDefault";
}
